// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WYF9","colMin":"styles_colMin__2Z3Ut"};